export const roleApi = {
  listRole: '/rdp/console/api/v1/role/listRole',
  listRoleAuth: '/rdp/console/api/v1/role/listRoleAuth',
  listAllAuthLabel: '/rdp/console/api/v1/role/listRoleAuthLabelTree',
  createRole: '/rdp/console/api/v1/role/createRole',
  updateRole: '/rdp/console/api/v1/role/updateRole',
  deleteRole: '/rdp/console/api/v1/role/deleteRole',
  fetchRole: '/rdp/console/api/v1/role/fetchRole'
};
